import { NgModule } from "@angular/core";
import { SafeHtml } from "./safeHtml";

@NgModule({
    declarations: [SafeHtml],
    exports: [SafeHtml]
})
export class SafeHtmlModule {}